import { useMemo } from "react";
import { useShallow } from "zustand/shallow";
import { useBoundStore } from "@/app/store";
import { ToolbarEdit } from "@/features/notes/components/Editor/components/ToolbarEdit";
import { ToolbarPreview } from "@/features/notes/components/Editor/components/ToolbarPreview";
import { usePageLayout } from "@/app/hooks/usePageLayout";

export function NoteSettingsToolbarRoute() {
  const { userId, toolbarItems, updateSettings } = useBoundStore(
    useShallow((state) => ({
      userId: state.user.id,
      toolbarItems: state.settings.notes.editorToolbarItems,
      updateSettings: state.settings.updateSettings,
    }))
  );
  const deviceType = useBoundStore(useShallow((state) => state.device.type));
  const isMobile = deviceType === "mobile";

  const handleToggle = (itemId: string) => {
    const updated = toolbarItems.map((item) => (item.id === itemId ? { ...item, enabled: !item.enabled } : item));

    // Update settings with new enabled items
    if (userId) {
      updateSettings(userId, {
        notes: { ...useBoundStore.getState().settings.notes, editorToolbarItems: updated },
      });
    }
  };

  const handleReorder = (reorderedItems: typeof toolbarItems) => {
    // Update settings with new order
    if (userId) {
      updateSettings(userId, {
        notes: { ...useBoundStore.getState().settings.notes, editorToolbarItems: reorderedItems },
      });
    }
  };

  const pageLayoutConfig = useMemo(() => ({ navbar: { title: "Toolbar" } }), []);
  usePageLayout(pageLayoutConfig);

  return (
    <>
      <div className="mx-auto h-full max-w-lg">
        <ToolbarEdit
          className="max-h-[calc(100%-74px)] overflow-auto"
          items={toolbarItems}
          onToggle={handleToggle}
          onReorder={handleReorder}
          isMobile={isMobile}
        />
        <ToolbarPreview className="mt-2" items={toolbarItems} />
      </div>
    </>
  );
}
